// The decision page's documents and choices, kept pure so they are unit-tested (documents.test.js).

const CERTIFICATES = new Set(['GST_CERTIFICATE', 'PAN_CARD', 'MSME_CERTIFICATE', 'INCORPORATION_CERTIFICATE']);
// Signed during registration: NDA_Agreement.pdf, SA_Agreement.pdf, Self_Declaration.pdf, Code_of_Conduct.pdf, …
const SIGNED = /(agreement|declaration|code[_ -]?of[_ -]?conduct)/i;

export const DOC_GROUPS = [
  { key: 'certificates', title: 'Certificates', hint: 'Uploaded by the supplier' },
  { key: 'agreements', title: 'Agreements and declarations', hint: 'Signed during registration' },
  { key: 'other', title: 'Other documents', hint: null },
];

export function docGroup(doc) {
  if (CERTIFICATES.has(doc.document_type)) return 'certificates';
  if (doc.document_type === 'MSME_DECLARATION' || SIGNED.test(doc.file_name || '')) return 'agreements';
  return 'other';
}

/** Non-empty groups in a fixed order; each keeps the server's order inside it. */
export function groupDocuments(docs) {
  return DOC_GROUPS.map((g) => ({ ...g, docs: (docs || []).filter((d) => docGroup(d) === g.key) })).filter((g) => g.docs.length > 0);
}

/** How a document can be shown inside the page. */
export function fileKind(doc) {
  const mime = String(doc?.mime_type || '').toLowerCase();
  const name = String(doc?.file_name || '').toLowerCase();
  if (mime === 'application/pdf' || name.endsWith('.pdf')) return 'pdf';
  if (mime.startsWith('image/') || /\.(png|jpe?g|gif|webp)$/.test(name)) return 'image';
  return 'other';
}

export function fmtSize(bytes) {
  const n = Number(bytes);
  if (!Number.isFinite(n) || n <= 0) return '';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

/** The choice the e-mail button made (?decision=approve|reject); the page still asks to confirm. */
export function initialChoice(search) {
  const v = new URLSearchParams(search || '').get('decision');
  return v === 'approve' ? 'APPROVED' : v === 'reject' ? 'REJECTED' : null;
}
